import { StreemAPI, StreemApiExpertTradeArea } from '@streem/api';
import { localStoreHookFactory } from './local_store_hook_factory';
import { ListStore } from '../stores/list_store';
import { useActiveCompanyCode } from './use_active_company_code';
import { useEffect, useState } from 'react';
import { CompanySettingsStore } from '../stores/company_settings_store';
import { APICallState } from '../stores/api_call_store';
import { autorun } from 'mobx';

const [createGetCompanyHoursOfOperation] = localStoreHookFactory(
    'GetCompanyHoursOfOperation',
    () =>
        new ListStore(StreemAPI.companies.getCompanyHoursOfOperation.bind(StreemAPI.companies), {
            filter: r => r.expertTradeArea ?? [],
            fnName: 'getCompanyHoursOfOperation',
        }),
);

export function useHoursOfOperation(
    companySettingsStore: CompanySettingsStore,
): StreemApiExpertTradeArea[] {
    const companyCode = useActiveCompanyCode();
    const hoursOfOperationStore = createGetCompanyHoursOfOperation();
    const [results, setResults] = useState<StreemApiExpertTradeArea[]>([]);

    useEffect(() => {
        if (companySettingsStore.expertAvailabilityEnabled) {
            const fetchPromise = hoursOfOperationStore.fetch(companyCode);
            return function () {
                fetchPromise.cancel();
            };
        }
    }, [companyCode, companySettingsStore.expertAvailabilityEnabled, hoursOfOperationStore]);

    useEffect(() => {
        const disposer = autorun(() => {
            if (hoursOfOperationStore.state === APICallState.complete) {
                setResults(hoursOfOperationStore.results);
            } else {
                setResults([]);
            }
        });

        return disposer;
        // using autorun--mox will call the function when observables change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return results;
}
